import { currencies } from "@/common/currencies";
import { DEFAULT_LOCALE } from "@/common/date.common";
import React from "react";

interface CurrencyAmountProps {
  amount: number;
  currency: string;
  className?: string;
}

export const CurrencyAmount: React.FC<CurrencyAmountProps> = ({
  amount,
  currency,
  className = "",
}) => {
  const upperCurrency = currency.toUpperCase();
  const currencySymbol = currencies[upperCurrency]?.symbol || upperCurrency;
  const formattedAmount = amount.toLocaleString(DEFAULT_LOCALE, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  return (
    <span className={className}>
      {currencySymbol}{formattedAmount}
    </span>
  );
};
